import { useState, useEffect } from 'react';
import { formatDisplayNumber } from '@/utils/formatNumber';

export interface IUserActionCount {
  className?: string;
  count: number;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * 格式化用户行为数量，如：点赞数、收藏数
 * @param cnt 数量
 * @returns string
 */
const useFormatActionCount = (cnt: number) => {
  const [count, setCount] = useState<string>(cnt.toString());

  useEffect(() => {
    setCount(formatDisplayNumber(cnt));
  }, [cnt]);

  return count;
};

export {
  useFormatActionCount,
};
